import {
    ContentType,
    IPictureFileMetadataResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { normalizeImageFileRotation } from 'utils/file';
import { Filter } from 'utils/query_v3';

const filterExp = Filter.and(
    Filter.eq('FileType', 'Folder'),
    Filter.eq('IsRootFolder', true)
);
export type UploadMapImageRequest = Readonly<{
    corporationId: string;
    locationId?: string;
    groupId?: string;
    type: ContentType;
    file: File;
}>;

export type UseUploadFileOptions = Readonly<{
    onSuccess?: () => void;
}>;

export const getRootFolder = async (
    corporationId: string,
    locationId: string | undefined
) => {
    if (locationId) {
        const result = await sdClient.getLocationFiles({
            locationId,
            filter: filterExp,
            page: 1,
            pageLimit: 1,
        });
        // TODO: This cast is necessary because array access is not type safe without
        // the --allowUncheckedIndexedAccess flag in tsconfig.json
        return result.Result[0] as IPictureFileMetadataResponse | undefined;
    }
    const result = await sdClient.getCorporationFiles({
        corporationId,
        filter: filterExp,
        page: 1,
        pageLimit: 1,
    });
    // TODO: This cast is necessary because array access is not type safe without
    // the --allowUncheckedIndexedAccess flag in tsconfig.json
    return result.Result[0] as IPictureFileMetadataResponse | undefined;
};

const uploadMapImage = async ({
    corporationId,
    locationId,
    // TODO: is this... supposed to be used?
    groupId: _groupId,
    type,
    file,
}: UploadMapImageRequest) => {
    const rootFolder = await getRootFolder(corporationId, locationId);
    if (!rootFolder) {
        throw new Error('Unable to find root file. Can not upload file.');
    }

    const normalizedFile = await normalizeImageFileRotation(file);

    return sdClient.createFile({
        fileType: type,
        displayName: file.name,
        parentFolderId: rootFolder.Id,
        locationId,
        corporationId,
        groupIds: undefined, // Only asset is supported here
        files: {
            data: normalizedFile,
            fileName: file.name,
        },
    });
};
export function useUploadFile(
    options?: UseMutationOptions<
        IPictureFileMetadataResponse,
        unknown,
        UploadMapImageRequest
    >
) {
    return useMutation({
        mutationFn: uploadMapImage,
        ...options,
    });
}
